/**
 * Competencia mensal, no formato `AAAA-MM` que o contrato exige.
 *
 * A competencia e mensal e nenhum documento fixa o dia de corte — a pendencia
 * esta registrada no plano da onda. O que a tela precisa e apenas do rotulo do
 * mes, e ele nasce **em UTC**: derivar do fuso do navegador faria a mesma
 * pessoa ver competencias diferentes conforme o lugar de onde abrisse a tela,
 * na virada do mes.
 */
export function currentPeriod(): string {
  const now = new Date();
  return `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`;
}

const PERIOD = /^[0-9]{4}-(0[1-9]|1[0-2])$/;

/**
 * Verdadeiro quando a competencia tem a forma que o contrato aceita.
 *
 * Serve para a tela nao emitir a consulta com um valor que o servidor vai
 * recusar com 400 enquanto a pessoa ainda esta digitando.
 */
export function isPeriod(value: string): boolean {
  return PERIOD.test(value);
}
